import React from 'react';
import Box, { type BoxProps } from '@mui/material/Box';

export type AppPageProps = BoxProps;

/**
 * Standard page column inside the app shell (shell already applies `p: 3`).
 * Fills available height for master–detail and wizard layouts.
 */
const AppPage: React.FC<AppPageProps> = ({ sx, children, ...props }) => (
  <Box
    sx={{
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      boxSizing: 'border-box',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default AppPage;
